
import HTTP from '@/config/axios-config-formdata'

const ServicesAuth = {

  //WS que se cambio para no tener que estar accediendo al ERP
  getTokenInfo (tira) {
    const payload = `token=${tira}`
    return HTTP.post('/memCacheInfo', payload)
      .catch(err => {
        throw err
      })
  }
}

export default ServicesAuth
